export enum SigningMethodEnum {
  GOOGLE = 'Google',
  DOODLE = 'Doodle',
  DEFAULT = '',
  LINKEDIN = 'LinkedIn',
  APPLE = 'Apple',
  EMAIL = 'Email',
  TYPED = 'Typed',
}
